import { GatewayType } from 'components/pages/Lz/LzTab/common/interface/interface';

export interface HeadCell {
  name: string;
}

export interface IOptions {
  label: string;
  value: string;
}

export enum EActionType {
  CREATE = 'create',
  EDIT = 'edit',
  VIEW = 'view',
  FILTER = 'filter',
  LIMIT = 'limit',
}

export enum EActionDrawerType {
  CARDS = 'cards',
  USER = 'users',
}

export interface IActionPzuDrawerType {
  [EActionDrawerType.CARDS]: 'cards';
  [EActionDrawerType.USER]: 'users';
}

export enum EEditType {
  LS_EDIT = 'lsEdit',
  PASSPORT_EDIT = 'passportEdit',
}

export enum EModalType {
  CONFIRM = 'confirm',
  BLOCK = 'block',
  ARCHIVE = 'archive',
}

export enum CommissionMode {
  MANUAL = 'MANUAL',
  AUTO = 'AUTO',
  AUTO_DAILY = 'AUTO_DAILY',
}

export const commissionOptions = [
  { label: 'Автоматический', value: CommissionMode.AUTO },
  { label: 'По платежным требованиям', value: CommissionMode.MANUAL },
  { label: 'Ежедневно', value: CommissionMode.AUTO_DAILY },
];

export const executivePositionOptions = [
  {
    label: 'Генеральный директор',
    value: 'Генеральный директор',
  },
  {
    label: 'Директор',
    value: 'Директор',
  },
  {
    label: 'Индивидуальный предприниматель',
    value: 'Индивидуальный предприниматель',
  },
];

export enum RecognizeType {
  ON = 'ON',
  OFF = 'OFF',
}

export enum EDirtinessFormula {
  NET_FROM_DIRTINESS = 'NET_FROM_DIRTINESS',
  DIRTINESS_FROM_NET = 'DIRTINESS_FROM_NET',
}

export const passportSettingsOptions = [
  { label: 'Включено', value: 'true' },
  { label: 'Выключено', value: 'false' },
];

export const dirtinessFormulaOptions = [
  { label: 'Нетто на основе засора', value: EDirtinessFormula.NET_FROM_DIRTINESS },
  { label: 'Засор на основе нетто', value: EDirtinessFormula.DIRTINESS_FROM_NET },
];

export const gatewayTypeOptions = [
  { label: 'DTB', value: GatewayType.DTB },
  { label: 'SberApi', value: GatewayType.SBER_API },
];

export const smsConfirmationOptions = [
  { label: 'Включено', value: 'REQUIRED' },
  { label: 'Выключено', value: 'NOT_REQUIRED' },
];

export const smsConfirmationModeOptions = [
  { label: 'Подтверждение клиентом', value: 'LZ_CLIENT' },
  { label: 'Подтверждение пользователем', value: 'USER' },
];

export interface IActionType {
  [EActionType.CREATE]: 'create';
  [EActionType.EDIT]: 'edit';
  [EActionType.VIEW]: 'view';
  [EActionType.FILTER]: 'filter';
  [EActionType.LIMIT]: 'limit';
}

type IFormFieldType = 'input' | 'select' | 'phone' | 'radio' | 'empty' | 'mask' | 'password' | 'date';

export interface IFormField {
  label: string;
  name: string;
  type: string;
  required: boolean;
  placeholder: string;
  fieldType: IFormFieldType;
  disabled: boolean | undefined;
  helperText?: string;
  inputLabel?: string;
  hidden?: boolean;
}
export interface IFormFieldForRadio {
  label: string;
  value: string;
  type: string;
  required: boolean;
  fieldType: IFormFieldType;
  disabled: boolean;
}

export interface IFormCommissionField {
  label: string;
  name: string;
  type: string;
  required: boolean;
  placeholder: string;
  fieldType: IFormFieldType;
  disabled: boolean;
}

export enum ESelectInputKey {
  SELECT = 'SELECT',
  SELECT_WITH_TAGS = 'SELECT_WITH_TAGS',
  SELECT_MINI = 'SELECT_MINI',
  SELECT_WITH_MASK = 'SELECT_WITH_MASK',
}

export enum LoginWeb {
  ALLOW = 'true',
  NON_ALLOW = 'false',
}

export type TIndexType = 'A' | 'B' | 'C';

export type ETooltipPlacment =
  | 'bottom'
  | 'left'
  | 'right'
  | 'top'
  | 'bottom-end'
  | 'bottom-start'
  | 'left-end'
  | 'left-start'
  | 'right-end'
  | 'right-start'
  | 'top-end'
  | 'top-start';

export const enum LoginTwoFactorMode {
  NOT_REQUIRED = 'NOT_REQUIRED',
  SMS = 'SMS',
  OTP = 'OTP',
}
